import React from "react";
import NavBar from "../Comp/NavBar";
import Footer from "../Comp/Footer";
import SignIn from "../Comp/Login/SignIn";
import Register from "../Comp/Login/Register";

const Login = () => (
  <>
    <NavBar />
    <div className="oot-auth">
      <h1>Welcome to Ootlob</h1>
      <p className="sub">Sign in to your account, or create a new one to start shopping.</p>
      <div className="oot-auth-grid">
        <div className="oot-auth-card">
          <h2>Sign In</h2>
          <SignIn />
        </div>
        <div className="oot-auth-card">
          <h2>Create Account</h2>
          <Register />
        </div>
      </div>
    </div>
    <Footer />
  </>
);

export default Login;
